import React, { useEffect, useState } from 'react'

import { HttpService, API, Title, DateFormat, Spinner, ExportToExcel } from '../../config/react'
import DataTable from 'react-data-table-component'

const SearchTerm = () => {
  const [SearchTerms, setSearchTerms] = useState([])
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const DefaultFilters = {
    page: 1,
    search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalRows, settotalRows] = useState()
  const [, setTyping] = useState(false)
  const [paused, setPaused] = useState(false)
  let typingTimeout = null
  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }
  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page_size: e })
  }

  const handleInputChange = (e) => {
    setCustomFilters({ ...CustomFilters, page: 1, search: e.target.value })
    setTyping(true)
    setPaused(false)
    if (typingTimeout) {
      clearTimeout(typingTimeout)
    }
    typingTimeout = setTimeout(() => {
      setTyping(false) // Typing stops
      setPaused(true) // Paused after the timeout
    }, 1000)
  }
  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Keyword"
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) => handleInputChange(e)}
      />
    )
  })
  const columns = [
    {
      name: 'Keyword',
      selector: (row) => row.keyword,
      sortable: true,
      sortField: 'keyword'
    },
    {
      name: 'Number of Uses',
      selector: (row) => row.no_of_users,
      sortable: true,
      sortField: 'number_of_uses'
    },
    {
      name: 'Number of Results',
      selector: (row) => row.no_of_result,
      sortable: true,
      sortField: 'number_of_results'
    },
    {
      name: 'Last Search Date',
      selector: (row) => <DateFormat value={row.updated_at}></DateFormat>,
      sortable: true,
      sortField: 'last_search'
    }
    // ,
    // {
    //     name: 'Action',
    //     selector: (row) =>
    //         <div className="action-btn">
    //             <Link onClick={e => DeleteKeyword(e, row.id)} to="" className="text-dark" title="Delete" ><i className="fa fa-trash-o" aria-hidden="true"></i> </Link>
    //         </div>
    //     ,
    // },
  ]
  useEffect(() => {
    setIsAuth(true)
    document.title = Title.SearchTerms
    GetKeywordList()
  }, [!paused, CustomFilters])
  useEffect(() => {
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout)
      }
    }
  }, [])

  const GetKeywordList = () => {
    const param = {
      page: CustomFilters.page,
      search: CustomFilters.search,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    setLoading(true)
    HttpService.postApi(API.GetSearchTerms, param).then((response) => {
      setLoading(false)
      if (response.data.status === true && response.data.result !== '') {
        const data = response.data.result
        setSearchTerms(data[1])
        setForceUpdate(!isForceUpdate)
        settotalRows(response.data.result[0][0].total)
      } else {
        setSearchTerms([])
        settotalRows(0)
      }
    })
  }
  const handleSort = (e, direction) => {
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }

  const handleExportExcel = () => {
    HttpService.postApi(API.GetSearchTermsExcel).then((response) => {
      if (response.data.result) {
        ExportToExcel(response.data.result[0], 'Search Terms')
      }
    })
  }

  // const DeleteKeyword = async (e, id) => {
  //   e.preventDefault()
  //   swal(Messages.SwalDeleteProp).then(function (isConfirm) {
  //     if (isConfirm) {
  //       var param = {
  //         id: id,
  //         IsDeleted: true,
  //         deleted_by: user.id
  //       }
  //       HttpService.postApi(API.DeleteBlog, param).then((response) => {
  //         toast.success(Messages.RecordDeleted)
  //         GetKeywordList()
  //         setForceUpdate(!isForceUpdate)
  //       })
  //     }
  //   })
  // }
  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.SearchTerms} </h3>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <button
                className="btn btn-primary float-right m-1"
                onClick={handleExportExcel}
              >
                Export Excel
              </button>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={SearchTerms}
                  pagination
                  paginationServer
                  persistTableHead={true}
                  // paginationPerPage={10}
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  onSort={handleSort}
                  subHeaderComponent={subHeaderComponentMemo}
                  paginationDefaultPage={currentPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default SearchTerm
